export const GET_VENDOR_COMPLETION_INFO = 'GET_VENDOR_COMPLETION_INFO';
export const GET_VENDOR_LIST = 'GET_VENDOR_LIST';
export const GET_SERVICES_QUESTIONNAIRES = 'GET_SERVICES_QUESTIONNAIRES';
export const GET_MENU_QUESTIONNAIRES = 'GET_MENU_QUESTIONNAIRES';
export const GET_VENDOR_QUESTIONNAIRES_RESPONSE =
    'GET_VENDOR_QUESTIONNAIRES_RESPONSE';
export const DISPLAY_VENDOR_QUESTIONNAIRES_RESPONSE =
    'DISPLAY_VENDOR_QUESTIONNAIRES_RESPONSE';
export const GET_PACKAGES = 'GET_PACKAGES';
export const GET_QUESTIONNAIRE_CATEGORIES = 'GET_QUESTIONNAIRE_CATEGORIES';
export const GET_QUESTIONNAIRE_SUBCATEGORIES =
    'GET_QUESTIONNAIRE_SUBCATEGORIES';

// The questionnaire that we are going to summarize
export const SET_CURRENT_QUESTIONNAIRE = 'SET_CURRENT_QUESTIONNAIRE';

// The summary for this questionnaire on all vendors
export const GET_CURRENT_SCM_QUESTIONNARE_SUMMARY_DATA =
    'GET_CURRENT_SCM_QUESTIONNARE_SUMMARY_DATA';

export const GET_CATEGORY_COMPLETION_FOR_USER =
    'GET_CATEGORY_COMPLETION_FOR_USER';

// Sets the current vendor that we need a summary of
export const SET_CURRENT_VENDOR = 'SET_CURRENT_VENDOR';
export const SET_CURRRENT_SUPPLY_CHAIN_CATEGORY =
    'SET_CURRRENT_SUPPLY_CHAIN_CATEGORY';
export const SET_REPORT_MANAGEMENT_SUMMARY_TYPE =
    'SET_REPORT_MANAGEMENT_SUMMARY_TYPE';

export const GET_CURRENT_VENDOR_INFO = 'GET_CURRENT_VENDOR_INFO';
export const GET_SECONDARY_SCM_QUESTIONNARY_SUMMARY_DATA =
    'GET_SECONDARY_SCM_QUESTIONNARY_SUMMARY_DATA';
export const QUESTIONNAIRE_LIST_LOADED = 'QUESTIONNAIRE_LIST_LOADED';
export const QUESTIONNAIRE_SUMMARY_LOADED_ALL_VENDORS =
    'QUESTIONNAIRE_SUMMARY_LOADED_ALL_VENDORS';
export const QUESTIONNIARE_SUMMARIES_LOADED_VENDOR =
    'QUESTIONNIARE_SUMMARIES_LOADED_VENDOR';
export const CATEGORY_SUMMARY_LOADED_VENDOR = 'CATEGORY_SUMMARY_LOADED_VENDOR';
export const VENDOR_INFO_LOADED = 'VENDOR_INFO_LOADED';
export const SUPPLY_CHAIN_CATEGORY_SUMMARY_LOADED =
    'SUPPLY_CHAIN_CATEGORY_SUMMARY_LOADED';

export const SUPPLY_CHAIN_CATEGORY_QUESTIONS_LOADED =
    'SUPPLY_CHAIN_CATEGORY_QUESTIONS_LOADED';



// WEBPACK FOOTER //
// ./src/redux/vendor/types.js